import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Row, Col, Alert, Clearfix, Button } from 'react-bootstrap';
import langs from 'langs';
import { find as _find, isObject as _isObject } from 'lodash';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { translateCmsTemplate } from 'actions/CmsActions';
import { addNotification } from 'actions/NotificationsActions';
import { getThumbFileFromEntity } from 'helpers/items';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormSwitchery from 'components/forms/FormSwitchery';
import FormInput from 'components/forms/FormInput';
import FormRadio from 'components/forms/FormRadio';
import FormRichEditor from 'components/forms/FormRichEditor';
import FormImageWithPreview from 'components/forms/FormImageWithPreview';

import CmsTemplateTypes from 'components/forms/cms/CmsTemplateTypes';

class CmsTemplateData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      showChangeParent: false,
    };
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      cmsTranslation,
      formStatusImage,
      doNotify,
    } = this.props;

    if (prevProps.cmsTranslation.pending && !cmsTranslation.pending) {
      // a translation was created, navigate to edit the translated template
      doNotify(1, messages.page_translate_created);
      this.navigatePage(cmsTranslation.data.id);
    }

    if (prevProps.formStatusImage.pending && !formStatusImage.pending && !formStatusImage.hasError) {
      // image has been uploaded, update the entity
      const value = this.props.entity.createValue('preview', [], formStatusImage.response);
      const newEntity = { ...this.props.entity.updateValue('preview', value) };
      this.props.changeEntity(newEntity);

      doNotify(1, messages.file_uploaded);
    }
  };

  navigatePage = cmsTemplateId => {
    this.props.history.push(this.props.appIntl.urlPrefix + 'account/settings/cmsTemplates/' + cmsTemplateId);
  };

  fileUpload = (name, images) => {
    const { entity } = this.props;

    if (_isObject(images) && images.length === 1) {
      const data = new FormData();
      data.append('image', images[0]);

      this.props.uploadPreview(entity.getId(), data);
    }
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      user,
      disabled,
      inModal,
    } = this.props;

    let imageUrl;
    if (entityLoaded) {
      if (entity.getPreview().getId()) {
        const thumbnail = getThumbFileFromEntity(entity.getPreview());
        if (thumbnail) {
          imageUrl = thumbnail.getWebLink();
        }
      }
    }

    return (
      <div className="clearfix">
        {entityLoaded && (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div className="panel panel-transparent">
                <div className="panel-body">
                  <p className="form-group-title">{messages.template}</p>
                  <div className="form-group-attached">
                    <FormInput
                      label={messages.name}
                      name="name"
                      value={entity.getName()}
                      meta={entity.getNameMetaInformation()}
                      validation={entity.getNameValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormRichEditor
                      label={messages.description}
                      name="description"
                      value={entity.getDescription()}
                      meta={entity.getDescriptionMetaInformation()}
                      validation={entity.getDescriptionValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <CmsTemplateTypes
                      value={entity.getType()}
                      meta={entity.getTypeMetaInformation()}
                      validation={entity.getTypeValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormImageWithPreview
                      label={messages.image}
                      name="image"
                      url={imageUrl}
                      onChange={this.fileUpload}
                      onReset={this.fileReset}
                      pending={this.props.formStatusImage.pending}
                    />
                  </div>

                  <p className="m-t-10 form-group-title">{messages.main_menu}</p>
                  <div className="form-group-attached">
                    <FormRadio
                      name="menuBackground"
                      label={messages.menu_transparent}
                      value={entity.getMenuBackground()}
                      meta={entity.getMenuBackgroundMetaInformation()}
                      validation={entity.getMenuBackgroundValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      options={[{ label: messages.yes, value: 'transparent' }, { label: messages.no, value: '' }]}
                    />
                    <FormRadio
                      name="menuVersion"
                      label={messages.menu_version}
                      value={entity.getMenuVersion()}
                      meta={entity.getMenuVersionMetaInformation()}
                      validation={entity.getMenuVersionValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      options={[
                        { label: messages.menu_light, value: 'light' },
                        { label: messages.menu_dark, value: 'dark' },
                      ]}
                    />
                    <FormRadio
                      name="logoVersion"
                      label={messages.logo_version}
                      value={entity.getLogoVersion()}
                      meta={entity.getLogoVersionMetaInformation()}
                      validation={entity.getLogoVersionValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      options={[
                        { label: messages.logo_default, value: 'default' },
                        { label: messages.logo_scroll, value: 'scroll' },
                      ]}
                    />
                  </div>

                  <p className="m-t-10 form-group-title">{messages.footer}</p>
                  <div className="form-group-attached">
                    <div className="form-group form-group-default padding-10">
                      <FormSwitchery
                        name="hideFooter"
                        label={messages.hide_footer}
                        checked={entity.getHideFooter()}
                        value
                        onChange={this.updateEntity}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} md={inModal ? 12 : 6}>
              <div className="panel panel-transparent">
                <div className="panel-body">
                  {user.project_lang.project_languages.length > 1 && (
                    <div>
                      <p className="m-t-10 form-group-title">{messages.language}</p>
                      <div className="form-group-attached">

                        {user.project_lang.project_languages.map((language, i) => {
                          const langVersion = _find(entity.getLangVersions(), ['language', language]);

                          if (
                            !langVersion ||
                            entity.getLanguage() === language ||
                            langVersion.getPageId() === entity.getId()
                          ) {
                            return (
                              <div className="radio radio-success" key={language}>
                                <input
                                  disabled={disabled}
                                  id={'cmsLanguage' + i}
                                  name="language"
                                  type="radio"
                                  value={language}
                                  checked={entity.getLanguage() === language}
                                  onChange={e => this.updateEntity('language', e.target.value)}
                                />
                                <label for={'cmsLanguage' + i}>{langs.where('1', language).local}</label>
                              </div>
                            );
                          }

                          return null;
                        })}
                      </div>
                      <p className="m-t-10">{messages.translations}</p>
                      <div>
                        {entity.getLangVersions().length === 1 && (
                          <Alert bsStyle="info">{messages.page_has_no_translations}</Alert>
                        )}

                        {user.project_lang.project_languages.map((language, i) => {
                          if (language !== entity.getLanguage()) {
                            const langVersion = _find(entity.getLangVersions(), ['language', language]);

                            return langVersion ? (
                              <div key={language} className="m-b-5 padding-10 bg-master-lightest">
                                <i className="m-r-10 fa-fw fa fa-check text-success" />
                                {langs.where('1', language).local}
                                <div className="pull-right">
                                  <Button
                                    className="btn-rounded"
                                    bsSize="xsmall"
                                    onClick={() => this.navigatePage(langVersion.getPageId())}
                                  >
                                    {messages.edit}
                                  </Button>
                                </div>
                                <Clearfix />
                              </div>
                            ) : (
                              <div key={language} className="m-b-5 padding-10 bg-master-lightest">
                                <i className="m-r-10 fa-fw fa fa-times text-warning" />
                                {langs.where('1', language).local}
                                <div className="pull-right">
                                  <Button
                                    className="btn-rounded"
                                    bsSize="xsmall"
                                    onClick={() => this.props.doTranslate(entity.getId(), language)}
                                  >
                                    {messages.translate}
                                  </Button>
                                </div>
                                <Clearfix />
                              </div>
                            );
                          }

                          return null;
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
CmsTemplateData.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    formStatusImage: state.formStatus.cmsTemplatePreviewImage,
    cmsTranslation: state.cms.translateCmsTemplate,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    uploadPreview: (cmsTemplateId, args) => {
      formStatusDispatchHelper(
        'cmsTemplatePreviewImage',
        `/api/pagetemplates/${cmsTemplateId}/preview.json`,
        args,
        'post',
        dispatch
      );
    },
    doTranslate: (cmsTemplateId, language) => {
      dispatch(translateCmsTemplate(cmsTemplateId, language));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CmsTemplateData)
  )
);
